import { render, staticRenderFns } from "./NoticeResetPassword.vue?vue&type=template&id=72999bf2&"
import script from "./NoticeResetPassword.vue?vue&type=script&lang=js&"
export * from "./NoticeResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports